import { render, staticRenderFns } from "./chgCardQuery.vue?vue&type=template&id=1f73d475&scoped=true&"
import script from "./chgCardQuery.vue?vue&type=script&lang=js&"
export * from "./chgCardQuery.vue?vue&type=script&lang=js&"
import style0 from "./chgCardQuery.vue?vue&type=style&index=0&id=1f73d475&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73d475",
  null
  
)

export default component.exports